import apiClient from '../lib/aliyun/api'
import {addPublicParams} from '../lib/public'
import Vue from 'vue'

const vue = new Vue()

class Client {
  async handlePromise(promise,interface_name = '') {

    try {
      let result = await promise
      if (result.code !== 200) {
        throw result
      }
      return result.data
    } catch (err) {
      try{
        let result = await promise
        result =  JSON.parse(result)
        if (result.code !== 200) {
          throw result
        }
        return result.data
      }
      catch (e) {
        this.commonFail(err,interface_name)
      }
    }
  }

  commonFail(err,interface_name) {

    if (err == 'TypeError: Failed to fetch') {
      vue.$alert('网络请求失败，请稍后重试', {
        showCancelButton: true,
        confirmButtonText: '好的',
        center: true,
        callback: action => {
        }
      })
      return
    }
    if (err && err.message) {
      vue.$message.error(err.message)
    } else {
      vue.$alert(interface_name+'接口请求失败, 请稍后重试', {
        showCancelButton: true,
        confirmButtonText: '好的',
        center: true,
        callback: action => {
        }
      })
    }
    if (err && err.error) {
      console.error(err)
    }
  }

  /** 保存文件
   * @param {oId}               String 组织id
   * @param {caseId}            String 案件id
   * @param {kaitingId}         String 开庭id
   * @param {fileId}            String
   * @param {name}              String 文件描述
   * @param {phone}             String 手机号
   */
  async addFile (params) {
    const promise = apiClient.request('POST', '/addFile', params)
    return this.handlePromise(promise, '/addFile')
  }


  // 参数 必填
  // oId,caseId,kaitingId
  /** 获取文件列表
   * @param {oId}               String 组织id
   * @param {caseId}            String 案件id
   * @param {kaitingId}         String 开庭id
   */
  async getFiles(params){
    params = {
      ...params,
      ...addPublicParams()
    };
    const promise = apiClient.request('GET', '/getFilesAndRecord', params)
    return this.handlePromise(promise, '/getFilesAndRecord')
  }

  // 获取验证码 sendVerificationCode
  // post
  // 参数：phone
  async sendSMSCode (params) {
    const promise = apiClient.request('POST', '/sendVerificationCode', params)
    return this.handlePromise(promise, '/sendVerificationCode')
  }

  // 校验验证码：verifyCode
  // post
  // 参数：phone，code
  async verifyCode (params) {
    const promise = apiClient.request('POST', '/verifyCode', params)
    return this.handlePromise(promise, '/verifyCode')
  }

  // 获取room token：getVideoToken
  // post
  // 参数：oId，caseId，kaitingId，phone
  async getVideoToken (params) {
    params = {
      ...params,
      ...addPublicParams()
    };
    const promise = apiClient.request('GET', '/getVideoToken', params)
    return this.handlePromise(promise, '/getVideoToken')
  }

  // 参数：oId，caseId，kaitingId
  async getRoom (params) {

    const promise = apiClient.request('GET', '/getRoom', params)
    return this.handlePromise(promise, '/getRoom')
  }

  generateIdToken(params){
    const promise = apiClient.request('POST', '/generateIdToken', params)
    return this.handlePromise(promise, '/generateIdToken')
  }

}

const client = new Client()
export default client
